<template>
  <div>
      <i class="el-icon-delete" @click="deleteMdAccessories(value)" title="删除" style="margin-left: 20px;font-size: 15px"></i>
  </div>
</template>
<script>
  export default {
    data: function () {
      return {
        value: null,
        number: null,
      }
    },
    mounted() {

    },
    methods: {
      deleteMdAccessories(value) {
        let self = this
        console.log("value",value)
        self.$emit('clickModule', value)
      }
    }
  }
</script>
<style scoped>
  .stepSuc :hover {
    cursor: pointer;
  }
</style>
